/* This file is autogenerated by "pnpm run generateIconComponents" command */
import React from 'react';
import { SVGProps } from 'react';

const Search: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M6.2426 5.7574c-2.3367 2.3367-2.3367 6.1485 0 8.4852 2.1578 2.1578 5.5718 2.3169 7.9218.4972l4.2758 4.2758 1.0607-1.0606-4.2758-4.2758c1.8197-2.3501 1.6606-5.764-.4972-7.9218-2.3367-2.3368-6.1485-2.3368-8.4853 0M7.3033 6.818c1.7633-1.7633 4.6006-1.7633 6.364 0s1.7633 4.6006 0 6.364-4.6006 1.7633-6.364 0-1.7633-4.6006 0-6.364"/></svg>
);

export default Search;
